module.exports = __webpack_public_path__ + "static/media/nachttisch.4601cf32.jpg";